import request from '@/utils/request'

export function registerEsimsToEim(data) {
  return request({
    url: `/esims/register_eim`,
    method: 'post',
    data
  })
}

export function findEsimDetail(id) {
  return request({
    url: `/esims/${id}`,
    method: 'get'
  })
}

export function findEsimProfileLinks(id, params) {
  return request({
    url: `/esims/${id}/profile_links`,
    method: 'get',
    params
  })
}

export function findEsimEimOperationTasks(id, params) {
  return request({
    url: `/esims/${id}/eim_operation_tasks`,
    method: 'get',
    params
  })
}

export function findEsimEimOperationTask(id, taskId) {
  return request({
    url: `/esims/${id}/eim_operation_tasks/${taskId}`,
    method: 'get'
  })
}

export function abortEsimEimOperationTask(id, taskId) {
  return request({
    url: `/esims/${id}/eim_operation_tasks/${taskId}/abort`,
    method: 'post'
  })
}

export function downloadEsimProfile(id, data) {
  return request({
    url: `/esims/${id}/download_profile`,
    method: 'post',
    data
  })
}

export function enableEsimProfile(id, data) {
  return request({
    url: `/esims/${id}/enable_profile`,
    method: 'post',
    data
  })
}

export function disableEsimProfile(id, data) {
  return request({
    url: `/esims/${id}/disable_profile`,
    method: 'post',
    data
  })
}

export function deleteEsimProfile(id, data) {
  return request({
    url: `/esims/${id}/delete_profile`,
    method: 'post',
    data
  })
}

export function setEsimFallbackProfile(id, data) {
  return request({
    url: `/esims/${id}/set_fallback_profile`,
    method: 'post',
    data
  })
}

export function unsetEsimFallbackProfile(id) {
  return request({
    url: `/esims/${id}/unset_fallback_profile`,
    method: 'post',
    data: {}
  })
}

export function updateEsimEimData(id) {
  return request({
    url: `/esims/${id}/eim_data`,
    method: 'post'
  })
}
